<template>
  <div class="login">
    <div class="header clearfix">
      <router-link class="fl" to="/index"
        ><img src="~@/assets/imgs/Group10.png" alt="logo"
      /></router-link>
      <router-link class="fr" to="/index">返回网站首页>></router-link>
    </div>
    <div class="content">
      <div class="content_login">
        <p class="title">
          <span :class="{ active: activeFlag }" @click="activeFlag = true"
            >个人登陆</span
          >|<span :class="{ active: !activeFlag }" @click="activeFlag = false"
            >单位登陆</span
          >
        </p>
        <div v-show="activeFlag" class="msg">
          <label
            ><input
              placeholder="请输入手机号"
              maxlength="11"
              @blur="checkPhoneNum"
              v-model="telPhone"
              type="text" /><img src="~@/assets/imgs/telphone.png" alt="科研人才网-硕士科研人才招聘"
          /></label>
          <label
            ><input
              placeholder="请输入密码"
              @keyup.enter="personlogin"
              v-model="pPassword"
              type="password" /><img src="~@/assets/imgs/password.png" alt="科研人才网-硕士博士人才招聘"
          /></label>
          <span class="loginBtn" @click="personlogin">登陆</span>
          <p class="clearfix forget">
            <i class="fl register"
              >还没有账号：<span @click="personReg"
                >立即注册<img src="~@/assets/imgs/shape.png" alt="科研人才网-事业单位硕士博士科研人才招聘" /></span
            ></i>
            <span class="fr forgetPassword" @click="personFog">忘记密码？</span>
          </p>
        </div>
        <div v-show="!activeFlag" class="msg">
          <label
            ><input
              placeholder="请输入邮箱"
              @blur="checkemail"
              v-model="email"
              type="text" /><img
              style="top: 22px"
              src="~@/assets/imgs/email.png"
              alt="科研人才网-事业单位硕士博士人才招聘"
          /></label>
          <label
            ><input
              placeholder="请输入密码"
              @keyup.enter="companylogin"
              v-model="cPassword"
              type="password" /><img src="~@/assets/imgs/password.png" alt="科研人才网-硕士科研人才招聘"
          /></label>
          <span class="loginBtn" @click="companylogin">登陆</span>
          <p class="clearfix forget">
            <i class="fl register"
              >还没有账号：<span @click="companyReg"
                >立即注册<img src="~@/assets/imgs/shape.png" alt="科研人才网-博后科研人才招聘" /></span
            ></i>
            <span class="fr forgetPassword" @click="companyFog"
              >忘记密码？</span
            >
          </p>
        </div>
      </div>
    </div>
    <div class="footer clearfix">
      <div class="models fl clearfix">
        <img class="fl" src="~@/assets/imgs/strong.png" alt="科研人才网-研究院博后科研人才招聘" />
        <h3>强大的招聘平台</h3>
        <p>提供快捷、高效、可靠的网上招聘</p>
      </div>
      <div class="models fl clearfix">
        <img class="fl" src="~@/assets/imgs/opportunity.png" alt="科研人才网-企业博后科研人才招聘" />
        <h3>强大的招聘平台</h3>
        <p>提供快捷、高效、可靠的网上招聘</p>
      </div>
      <div class="models fl clearfix">
        <img class="fl" src="~@/assets/imgs/Group.png" alt="科研人才网-高校学术带头人引进" />
        <h3>强大的招聘平台</h3>
        <p>提供快捷、高效、可靠的网上招聘</p>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import { get, postWithJson, form } from "@/api/services";
import AppFooter from "../../components/common/footer.vue";
export default {
  name: "login",
  components: { AppFooter },
  data() {
    return {
      activeFlag: true,
      telPhone: "",
      pPassword: "",
      email: "",
      cPassword: "",
    };
  },
  created: function () {
    this.activeFlag =
      this.$route.query.loginFlag == undefined
        ? true
        : this.$route.query.loginFlag;

    localStorage.setItem("_token", "");
    localStorage.setItem("_id", "");
    localStorage.setItem("_userName", "");
    // let _id = sessionStorage.getItem('_id');
    // if(_id != "" && _id != null){
    // 	this.$router.push({
    // 		path:'/home'
    // 	});
    // }
  },
  methods: {
    personReg() {
      this.$router.push({ path: "/register", query: { jId: 0 } });
    },
    personFog() {
      this.$router.push({ path: "/forget", query: { jId: 0 } });
    },
    companyReg() {
      this.$router.push({ path: "/register", query: { jId: 1 } });
    },
    companyFog() {
      this.$router.push({ path: "/forget", query: { jId: 1 } });
    },
    checkPhoneNum: function () {
      // let _self = this;
      // let myreg = /^1\d{10}$/;
      // console.log("2")
      // if (!myreg.test(parseInt(_self.telPhone))) {
      //     this.$message({
      //         message: '请输入正确的手机号！',
      //         type: 'warning'
      //     });
      // }
    },
    checkemail: function () {
      let _self = this;
      let myreg =
        /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      if (!myreg.test(_self.email)) {
        this.$message({
          message: "请输入正确的邮箱地址！",
          type: "warning",
        });
      }
    },
    personlogin: function () {
      let _self = this;
      let myreg = /^1\d{10}$/;
      if (_self.telPhone == "" || !myreg.test(parseInt(_self.telPhone))) {
        this.$message({
          message: "请输入正确的手机号！",
          type: "warning",
        });
        return false;
      } else if (_self.pPassword == "") {
        this.$message({
          message: "请输入密码！",
          type: "warning",
        });
        return false;
      } else {
        postWithJson("front/login", {
          tel: _self.telPhone + "",
          passWord: _self.pPassword + "",
          userType: 1,
        }).then(
          function (response) {
            if (response.data.status) {
              _self.$message({
                message: "登陆成功！",
                type: "success",
              });
              let _token = response.data.data;
              // let _id = response.body.data.user_id;
              localStorage.setItem("_token", _token);
              localStorage.setItem("_id", _self.telPhone);
              localStorage.setItem("_userName", _self.telPhone);
              _self.$router.push({ path: "/index" });
              _self.setCookie("session_token", _token + "");
            } else {
              _self.$message({
                message: response.data.message,
                type: "error",
              });
            }
          },
          function (response) {
            console.log(response);
            _self.$message({
              message: response.data.message,
              type: "error",
            });
          }
        );
      }
    },
    companylogin() {
      let _self = this;
      let myreg =
        /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      if (_self.email == "" || !myreg.test(_self.email)) {
        this.$message({
          message: "请输入正确的邮箱地址！",
          type: "warning",
        });
        return false;
      } else if (_self.cPassword == "") {
        this.$message({
          message: "请输入密码",
          type: "warning",
        });
        return false;
      } else {
        postWithJson("front/login", {
          email: _self.email + "",
          passWord: _self.cPassword + "",
          userType: 2,
        }).then(
          function (response) {
            if (response.data.status) {
              let _token = response.data.data;
              localStorage.setItem("_token", _token);
              localStorage.setItem("_userName", _self.email);
              _self.$router.push({ path: "/companyCerter" });
              _self.setCookie("session_token", _token + "");
              // _self.$router.push({ path:'/unCertification'});
            } else {
              _self.$message({
                message: response.data.message,
                type: "error",
              });
            }
          },
          function (response) {
            _self.$message({
              message: response.data.message,
              type: "error",
            });
          }
        );
      }
    },
  },
};
</script>
<style scoped = "scoped"  lang = "less">
.login {
  background-color: white;
  .header {
    width: 1200px;
    margin: 0 auto;
    height: 105px;
    line-height: 105px;
    .fl {
      margin-top: 24px;
    }
    .fr {
      font-size: 16px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: rgba(23, 135, 251, 1);
    }
  }
  .content {
    width: 100%;
    height: 530px;
    background: url("~@/assets/imgs/loginBg.png") no-repeat center center;
    position: relative;
    .content_login {
      background-color: white;
      width: 390px;
      height: 350px;
      position: absolute;
      top: 90px;
      left: 50%;
      margin-left: 180px;
      padding: 30px 35px 35px;
      .title {
        /* color:rgba(102,102,102,1); */
        span {
          display: inline-block;
          width: 49%;
          text-align: center;
          font-size: 20px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          cursor: pointer;
          opacity: 0.6;
          color: #666;
        }
        span:hover {
          color: #333;
          opacity: 0.8;
        }
        .active {
          color: #1787fb;
          font-weight: bold;
          opacity: 1;
        }
        .active:hover {
          color: #1787fb;
          opacity: 1;
        }
      }
      .msg {
        label {
          display: block;
          position: relative;
          margin-top: 20px;
          input {
            width: 100%;
            height: 50px;
            text-indent: 40px;
          }
          img {
            position: absolute;
            left: 14px;
            top: 17px;
          }
        }
        .loginBtn {
          display: inline-block;
          width: 100%;
          height: 46px;
          line-height: 46px;
          text-align: center;
          color: white;
          background-color: #1787fb;
          border-radius: 4px;
          margin-top: 20px;
          cursor: pointer;
          font-size: 20px;
          letter-spacing: 4px;
        }
        .forget {
          margin-top: 20px;
          height: 36px;
          line-height: 36px;
          font-size: 14px;
          .register {
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: #333;
            font-style: normal;
            span {
              display: inline-block;
              width: 110px;
              margin-left: 4px;
              vertical-align: middle;
              border: 1px solid #1787fb;
              cursor: pointer;
              border-radius: 4px;
              text-align: center;
              color: #1787fb;
              img {
                vertical-align: middle;
                margin-left: 4px;
              }
            }
          }
          .forgetPassword {
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: #1787fb;
            cursor: pointer;
          }
        }
      }
    }
  }
  .footer {
    width: 1200px;
    margin: 60px auto 80px;
    .models {
      width: 33.3%;
      height: 58px;
      img {
        height: 58px;
        margin-right: 10px;
      }
      h3 {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 25px;
      }
      p {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 20px;
        margin-top: 10px;
      }
    }
  }
}
@media all and (max-width: 768px) {
  .login {
    .header {
      width: 100%;
    }
    .content {
      .content_login {
        width: 80%;
        left: 0;
        margin-left: 10%;
        height: 360px;
      }
    }
    .footer {
      width: 100%;
      margin: 30px auto 30px;
      .models {
        width: 100%;
        margin-top: 16px;
        padding-left: 20px;
      }
    }
    .footerBottom {
      .footer_top {
        height: 76px;
        line-height: 36px;
      }
      .footer_bottom {
        height: 250px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue